// extracted by mini-css-extract-plugin
module.exports = {"toggle-switch":"ToggleSwitch_toggle-switch__1QPlU","switch":"ToggleSwitch_switch__2K4Wg"};